import { GoogleTagManagerLoader } from "./GoogleTagManagerLoader";
import { HubSpotLoader } from "./HubSpotLoader";

// Consent-gated third-party tracker script loaders. Mounted app-wide (all auth
// states) so gating applies on the login page too; each renders null.
export function ConsentTrackerLoaders() {
  return (
    <>
      <GoogleTagManagerLoader />
      <HubSpotLoader />
    </>
  );
}
